module["exports"] = [
  "Mr.",
  "Mrs.",
  "Ms.",
  "Miss",
  "Dr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/name/prefix.js
 ** module id = 329
 ** module chunks = 0
 **/